var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1224 12.8752V11.5372C17.1224 10.2903 16.2646 9.24263 15.1036 8.94558M12.7484 1.02801C13.7349 1.42497 14.4307 2.38641 14.4307 3.50942C14.4307 4.63243 13.7349 5.59387 12.7484 5.99084M13.7578 12.8752C13.7578 11.6283 13.7578 11.0049 13.5529 10.5132C13.2797 9.85749 12.7557 9.33656 12.0962 9.06497C11.6016 8.86127 10.9745 8.86127 9.72031 8.86127H7.70156C6.4474 8.86127 5.82032 8.86127 5.32567 9.06497C4.66614 9.33656 4.14214 9.85749 3.86895 10.5132C3.66406 11.0049 3.66406 11.6283 3.66406 12.8752M11.4026 3.50942C11.4026 4.9873 10.1975 6.18535 8.71094 6.18535C7.22437 6.18535 6.01927 4.9873 6.01927 3.50942C6.01927 2.03155 7.22437 0.833496 8.71094 0.833496C10.1975 0.833496 11.4026 2.03155 11.4026 3.50942Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.832031 12.8752V11.5152C0.832031 10.2479 1.66554 9.18299 2.79357 8.88106M5.08203 0.833496C4.12355 1.23698 3.44742 2.2142 3.44742 3.35565C3.44742 4.4971 4.12355 5.47432 5.08203 5.87781",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupDetailsIcon);
export default __webpack_public_path__ + "static/media/group-details-icon.fe766facbd65cc050856f81af0c75832.svg";
export { ForwardRef as ReactComponent };